import utilsService from '../../services/utilsService';
import propertyService from '../../services/propertyService';
import _ from 'lodash';

import axios from 'axios';

// initial state
const state = {
  property:{},
  properties:{},
  center:{},
  currentZoom:null,
  maps:[],
  paths:[],
  nearBy:{},
  loading: false,
  hasProperties: undefined
}

// getters
const getters = {
  center(state) {
    return state.properties.center
  },
  images(state) {
    const images = []
    const preImages = state.property.building ?  _.union(state.property.building.images,state.property.images) : state.property.images;
      _.forEach(preImages,function(image){
        const obj = {
          src: image,
          thumb: image
        }
        images.push(obj)
    })
    return images
  }
}

// actions
const actions = {
  getProperty(context,id){
    return new Promise((resolve,reject)=>{
      const propertyPromise = propertyService.getById(id);
      propertyPromise
      .then((resp) => {
        context.commit('set_property', resp.data)
        resolve(resp.data)
      })
      .catch(err => {
        // context.commit('auth_error')
        reject(err)
      })
    })
  },
  favorite(context,id){
    return new Promise((resolve,reject)=>{
      const propertyPromise = propertyService.favorite(id,{});
      propertyPromise
      .then((resp) => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  properties(context,params){
    return new Promise((resolve,reject)=>{
      context.commit('set_loading', true)
      const propertyPromise = propertyService.getProperties(params);
      propertyPromise
      .then((resp) => {
        context.commit('set_properties', resp.data)
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
      .finally(() => {
        context.commit('set_loading', false)
      })
    })
  },
  maps(context, params){
    return new Promise((resolve, reject) => {
        propertyService.getMapMarks(params)
        .then(resp => {
          context.commit('set_map',resp.data)
          context.commit('set_current_zoom',resp.data.currentZoom)
          context.commit('set_center',resp.data.center)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  nearby(context, params){
    return new Promise ((resolve, reject) => {
        propertyService.getNearBy(params)
        .then(resp => {
            context.commit('set_nearBy',resp.data)
            resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  city(context, params){
    return new Promise((resolve, reject) => {
        propertyService.city(params)
        .then(resp => {
          context.commit('set_path',resp.data)
          resolve(resp)
        })
        .catch(err=>{
          reject(err)
        })
    })
  },
  hotProperties(context, params){
      return new Promise((resolve, reject) => {
          propertyService.getHotProperties(params)
          .then(resp => {
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      })
  },
  print(context, params,a){
      return new Promise((resolve, reject) => {
          propertyService.print(params.id,{language: params.language})
          .then(resp => {
              resolve(resp)
          })
          .catch(err => {
              reject(err)
          })
      })
  }

}

// mutations
const mutations = {
    set_property(state,response) {
      state.property = response
    },
    set_properties(state,response) {
      _.forEach(response.properties.data,function(property){
       const images =  _.concat(property.building.images, property.images)
        property.covers = images.length > 0 ? images : utilsService.defaultCover()
      })
      state.properties = response.properties
      state.hasProperties = response.hasProperties
    },
    set_current_zoom(state,num){
      state.currentZoom = num
    },
    set_center(state,center){
      if (center) {
        state.center = center
      }
    },
    set_map(state,maps){
      state.maps = maps
    },
    set_path(state, paths){
      state.paths = paths
    },
    set_nearBy(stata, data){
      state.nearBy = data
    },
    set_loading(state, flag){
      state.loading = flag
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}